import React from 'react';
import FormDialog from '../../../../library/form/components/FormDialog';
import withView from '../../../cmn/docAutomation/withView';
import FormInput from '../../../../library/form/components/FormInput';
import FormCheckbox from '../../../../library/form/components/FormCheckbox';
import FormLabel from '../../../../library/form/components/FormLabel';
import FormRichText from '../../../../library/form/components/FormRichText';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormTitle from '../../../../library/form/components/FormTitle';
import FormWrapper from '../../../../library/form/components/FormWrapper';
import FormROValue from '../../../../library/form/components/FormROValue1';

const AlarmHeaderEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;
    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }} contentStyle={{ height: '370px' }}
            formStyle={{ width: '743px' }} formTitle={<FormTitle formObject={formObject} value="Alarm Detail" />}
        >
            <div className="uiCol">
                <ul>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docId" }} value="Alarm ID" />
                        </span>
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "docId" }} className="uiVal" />

                        <span className="uiLblInLine">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "activateAlarm" }} value="Is Active" />
                        </span>
                        <FormCheckbox formObject={formObject} rowKey='' action={{ InputType: "onOff", paramName: "activateAlarm" }} />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "alarmTitle" }} value="Alarm Title" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiVal uiVal50p"
                            action={{ InputType: "input", paramName: "alarmTitle" }}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "targetDocType" }} value="Target Document" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiVal uiVal50p"
                            action={{ InputType: "ac", actionId:'refresh', paramName: "targetDocType", acMethod: "AlarmDocuments" }}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "alarmProcessMethod" }} value="Processing Method" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiVal uiVal50p"
                            action={{ InputType: "input", paramName: "alarmProcessMethod"}}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "alarmSubscriberCode" }} value="Subscriber Code" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiVal uiVal50p"
                            action={{ InputType: "input", paramName: "alarmSubscriberCode"}}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "enableSkipCriteria" }} value="Enable Skip Condition" />
                        </span>
                        <FormCheckbox formObject={formObject} rowKey='' className=""
                            action={{ InputType: "onOff", paramName: "enableSkipCriteria" }}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "copyOwner" }} value="Notify Owner" />
                        </span>
                        <FormCheckbox formObject={formObject} rowKey='' className=""
                            action={{ InputType: "onOff", paramName: "copyOwner" }}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "ownerSmsTpl" }} value="Owner SMS TPL" />
                        </span>
                        <FormRichText formObject={formObject} rowKey="" id="delInstTxt" className="uiVal50p" rows="5" cols="82"
                            action={{ paramName: "ownerSmsTpl" }}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "ownerEmailSub" }} value="Owner Email Sub" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiVal uiVal50p"
                            action={{ InputType: "input", paramName: "ownerEmailSub" }}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "ownerEmailTpl" }} value="Owner Email TPL" />
                        </span>
                        <FormRichText formObject={formObject} rowKey="" id="delInstTxt" className="uiVal50p" rows="5" cols="82"
                            action={{ paramName: "ownerEmailTpl" }}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "alarmReportTpl" }} value="Report Template" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiVal uiVal50p"
                            action={{ InputType: "input", paramName: "alarmReportTpl" }}
                        />
                    </li>
                </ul>
            </div>
            <div className="uiCol">
                <ul>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "alarmFrequency" }} value="Alarm Frequency" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiVal uiVal50"
                            action={{ InputType: "input", paramName: "alarmFrequency" }}
                        />

                        <span className="uiLblInLine">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "alarmFrequencyUnit" }} value="Unit" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiVal uiVal70"
                            action={{ InputType: "ac", paramName: "alarmFrequencyUnit", acMethod: "AlarmFrequency" }}
                        />
                    </li>
                    <li>
                        <span className="uiLblInLine">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "timeOffset" }} value="Which day" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiVal uiVal150"
                            action={{ InputType: "input", paramName: "whichDayOfFrequency" }}
                        />
                    </li>
                    <li>
                        <span className="uiLblInLine">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "timeOffset" }} value="@ Time (24 hrs with Offset)" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiVal uiVal70"
                            action={{ InputType: "input", paramName: "alarmTime" }}
                        />
                        <FormInput formObject={formObject} rowKey="" className="uiVal uiVal70"
                            action={{ InputType: "input", paramName: "timeOffset" }}
                        />
                    </li>
                    <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "sFrequencyContainer" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "sRRFrequency" }} value="Show Frequency" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiVal uiVal50"
                            action={{ InputType: "input", paramName: "sRRFrequency" }}
                        />

                        <span className="uiLblInLine">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "sRRFrequencyUnit" }} value="Unit" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiVal uiVal70"
                            action={{ InputType: "ac", paramName: "sRRFrequencyUnit", acMethod: "AlarmFrequency" }}
                        />

                        <SarasTrans value="For Repeat Record" />
                    </FormWrapper>
                    <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "nFrequencyContainer" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "nRRFrequency" }} value="Notify Frequency" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiVal uiVal50"
                            action={{ InputType: "input", paramName: "nRRFrequency" }}
                        />

                        <span className="uiLblInLine">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "nRRFrequencyUnit" }} value="Unit" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiVal uiVal70"
                            action={{ InputType: "ac", paramName: "nRRFrequencyUnit", acMethod: "AlarmFrequency" }}
                        />

                        <SarasTrans value="For Repeat Record" />
                    </FormWrapper>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "notifyType" }} value="Notify Type" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiVal uiVal50p"
                            action={{ InputType: "input", paramName: "notifyType"}}
                        />
                    </li>
                    <li>
                        <span className="uiLblInLine">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "attachToTask" }} value="Attach to Task" />
                        </span>
                        <FormCheckbox formObject={formObject} rowKey='' name="cbcostextravalue"
                            action={{ InputType: "onOff", paramName: "attachToTask" }}
                        />
                    </li>
                    <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "notifyParty" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "notifyParty" }} value="Notify Party" />
                        </span>
                        <FormCheckbox className="" formObject={formObject} rowKey='' action={{ InputType: "onOff", paramName: "notifyParty" }} />
                    </FormWrapper>
                    <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "partySmsTpl" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "partySmsTpl" }} value="Party SMS TPL" />
                        </span>
                        <FormRichText formObject={formObject} rowKey="" className="uiVal50p" rows="5" cols="82"
                            action={{ paramName: "partySmsTpl" }}
                        />
                    </FormWrapper>
                    <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "partyEmailSub" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "partyEmailSub" }} value="Party Email Sub" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" id="delHrsTxt" className="uiVal uiVal50p"
                            action={{ InputType: "input", paramName: "partyEmailSub" }}
                        />
                    </FormWrapper>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "partyEmailTpl" }} value="Party Email TPL" />
                        </span>
                        <FormRichText formObject={formObject} rowKey="" className="uiVal50p" rows="5" cols="82"
                            action={{ paramName: "partyEmailTpl" }}
                        />
                    </li>
                </ul>
            </div>

        </FormDialog>
    )
}

export default withView(AlarmHeaderEditor, "alarmHeader", "alarmHeader,alarmCriteria")
